import {Occasion} from "../../../../../../server/src/base/entities/occasion/Occasion";
import {IOccasionFilter} from "./IOccasionFilter";
import {IOccasions} from "../../../../../../server/src/base/entities/occasion/IOccasions";
import {OccasionsDecorator} from "../../../../../../server/src/base/entities/occasion/OccasionsDecorator";

export class OccasionsFilters extends OccasionsDecorator{

    private filteredOccasions:Array<Occasion>;
    private filters:Array<IOccasionFilter>;

    constructor(occasions:IOccasions){
        super(occasions);
        this.filters = [];
        this.filteredOccasions = this.occasions.Value();
        this.occasions.Updated().subscribe(() => {this.Update()});
    }

    public Update(){
        let newOccasionsFiltered = [];
        for(let occasion of this.occasions.Value()){
            if(this.IsOccasionValid(occasion)){
                newOccasionsFiltered.push(occasion);
            }
        }

        this.filteredOccasions = newOccasionsFiltered;
        this.updated.dispatch();
    }

    public Value():Array<Occasion>{
        return this.filteredOccasions;
    }

    private IsOccasionValid(occasion:Occasion) : boolean{
        for(let filter of this.filters){
            if(!filter.IsValid(occasion)){
                return false;
            }
        }
        return true;
    }

    public AddFilter(filter:IOccasionFilter){
        this.filters.push(filter);
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/occasions/filters/OccasionsFilters.ts